import React, { useState } from "react";
import {
  Card,
  Spin,
  Typography,
  message,
  Empty,
  Space,
  Tabs,
  Button,
  Modal,
  Tag,
  Progress,
  Row,
  Col,
  Divider,
} from "antd";
import dayjs from "dayjs";
import {
  AuditOutlined,
  FileTextOutlined,
  TransactionOutlined,
  SolutionOutlined,
  FolderOpenOutlined,
  TwitchOutlined,
  EyeOutlined,
  MailOutlined,
  FileSearchOutlined,
  FileProtectOutlined,
  CheckCircleOutlined,
  WalletOutlined,
  CalendarOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import PayInSlipModal from "../afterCourt/report/QRcode";
import AddImage from "./modal/AddImage";
import PreviewPayment from "./modal/PreviewPayment";
import BillAfterCourtOldData from "../afterCourt/modal/BillAfterCourtOldData";

import THEME from "./contractDetailNew/theme";
import { formatMoney } from "./contractDetailNew/utils";
import {
  USER_IDS,
  ROLE_IDS,
  HIA_APPROVED_STATUSES,
  JUDGMENT_REVIEWED_THRESHOLD,
} from "./contractDetailNew/constants";
import useContractDetailData from "./contractDetailNew/useContractDetailData";

import ContractHeader from "./contractDetailNew/tabs/ContractHeader";
import JudgementInfoTab from "./contractDetailNew/tabs/JudgementInfoTab";
import PaymentInCaseTab from "./contractDetailNew/tabs/PaymentInCaseTab";
import LoanNewInfoTab from "./contractDetailNew/tabs/LoanNewInfoTab";
import LoanNewInfoJudgeTab from "./contractDetailNew/tabs/LoanNewInfoJudgeTab";
import MortgageInfoTab from "./contractDetailNew/tabs/MortgageInfoTab";
import PaymentTab from "./contractDetailNew/tabs/PaymentTab";
import PaymentTabAcc from "./contractDetailNew/tabs/PaymentTabAcc";
import DuePaymentTab from "./contractDetailNew/tabs/DuePaymentTab";
import InvestigationInfoTab from "./contractDetailNew/tabs/InvestigationInfoTab";
import LoanInfoTab from "./contractDetailNew/tabs/LoanInfoTab";
import CustomerInfoTab from "./contractDetailNew/tabs/CustomerInfoTab";
import GuarantorsTab from "./contractDetailNew/tabs/GuarantorsTab";
import MemoTab from "./contractDetailNew/tabs/MemoTab";
import UploadImageTab from "./contractDetailNew/tabs/UploadImageTab";
import FollowCustomerTab from "./contractDetailNew/tabs/FollowCustomerTab";
import MailCustomerTab from "./contractDetailNew/tabs/MailCustomerTab";
import EnforcementTab from "./contractDetailNew/tabs/EnforcementTab";
import ThaiDatePicker from "../../../hook/ThaiDatePicker";
import LoanRejudgeTab from "./contractDetailNew/tabs/LoanRejudgeTab";
import DebtDetailTab from "./contractDetailNew/tabs/DebtDetailTab";

const { Text } = Typography;

// ==================== MAIN COMPONENT ====================
const Main = () => {
  const {
    userId,
    roleId,
    token,
    searchData,
    loadingJudge,
    loadingLoan,
    loadingImge,
    loanData,
    judgeData,
    activeTab,
    memoDataOld,
    setMemoDataOld,
    memoDataNew,
    showNoteOld,
    setShowNoteOld,
    showNoteNew,
    setShowNoteNew,
    editMemoOld,
    setEditMemoOld,
    remarkValueNew,
    setRemarkValueNew,
    billPayment,
    duePaymentData,
    beeypupData,
    remarkValueOld,
    followCusData,
    isModalpayIn,
    setIsModalPayIn,
    fileListByContractCourt,
    pdfPreviewOpen,
    setPdfPreviewOpen,
    pdfPreviewUrl,
    setPdfPreviewUrl,
    isModalAddImge,
    setIsModalAddImge,
    isModalPreviewPayment,
    setIsModalPreviewPayment,
    isModalBillAfterCourtOldData,
    setIsModalBillAfterCourtOldData,
    statusEms,
    mailData,
    loadApprovDue,
    setLoadApprovDue,
    loadLoanData,
    loadJudgeData,
    postMemoNew,
    postMemoOld,
    postApporve,
    handleTabChange,
    handleBillRequest,
    handleReload,
    handlePrintCardDebtor,
    exportCardDebtor,
    rejudgeData,
  } = useContractDetailData();

  const [isModalApproveDue, setIsModalApproveDue] = useState(false);
  const [approveDueDate, setApproveDueDate] = useState(null);

  const handleApproveDue = async () => {
    if (!approveDueDate) {
      return message.warning("กรุณาเลือกวันที่");
    }
    const paylod = {
      idJudge: judgeData.judge?.[0]?.idJudge,
      FDATE: dayjs(approveDueDate).format("YYYY-MM-DD"),
    };
    console.log("paylod", paylod);

    const result = await postApporve(paylod);
    setLoadApprovDue(false);
    if (result) {
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }

      loadJudgeData(searchData);
      setIsModalApproveDue(false);
      setApproveDueDate(null);
    }
  };

  // ==================== MAIN RENDER ====================
  if (!judgeData && !loadingJudge) {
    return (
      <Card
        style={{
          borderRadius: THEME.borderRadius,
          boxShadow: THEME.cardShadow,
          textAlign: "center",
          padding: 40,
        }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Space direction="vertical">
              <Text strong style={{ fontSize: 16 }}>
                ไม่มีข้อมูล
              </Text>
              <Text type="secondary">กรุณาค้นหาเลขสัญญาเพื่อดูรายละเอียด</Text>
            </Space>
          }
        />
      </Card>
    );
  }

  // ==================== TAB ITEMS ====================
  const tabItems = [
    {
      key: "1",
      label: (
        <span>
          <AuditOutlined /> ข้อมูลหลังพิพากษา
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <div>
            {judgeData ? (
              <>
                {
                  <JudgementInfoTab
                    judgeData={
                      judgeData?.currentNewContno === searchData.CONTNO
                        ? judgeData
                        : rejudgeData
                    }
                  />
                }
              </>
            ) : (
              !judgeData && <Empty description="ไม่มีข้อมูล" />
            )}
          </div>
        </Spin>
      ),
    },
    {
      key: "2",
      label: (
        <span>
          <FileTextOutlined /> ข้อมูลสัญญา(ใหม่)
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <>
            <div>
              {judgeData?.loanNew ? (
                <LoanNewInfoTab
                  judgeData={
                    judgeData?.currentNewContno === searchData.CONTNO
                      ? judgeData
                      : rejudgeData
                  }
                  handlePrintCardDebtor={handlePrintCardDebtor}
                  beeypupData={beeypupData}
                />
              ) : (
                <LoanNewInfoJudgeTab
                  judgeData={
                    judgeData?.currentNewContno === searchData.CONTNO
                      ? judgeData
                      : rejudgeData
                  }
                  handlePrintCardDebtor={handlePrintCardDebtor}
                  beeypupData={beeypupData}
                />
              )}
              <DebtDetailTab judgeData={judgeData} />
              <MortgageInfoTab loanData={loanData} />
            </div>
          </>
        </Spin>
      ),
    },
    // judgeData?.rejudge_from_id_judge && {
    //   key: "15",
    //   label: (
    //     <span>
    //       <FileTextOutlined /> ข้อมูลสัญญาก่อนรีไฟแนนซ์
    //     </span>
    //   ),
    //   children: (
    //     <Spin spinning={loadingJudge}>
    //       <>
    //         <div>
    //           {judgeData?.rejudge_from_id_judge && (
    //             <LoanRejudgeTab
    //               judgeData={judgeData}
    //               loanData={loanData}
    //               rejudgeData={rejudgeData}
    //             />
    //           )}
    //         </div>
    //       </>
    //     </Spin>
    //   ),
    // },
    judgeData?.enforcement && {
      key: "14",
      label: (
        <span>
          <FileTextOutlined /> ข้อมูลส่งบังคับคดี
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <EnforcementTab judgeData={judgeData} />
        </Spin>
      ),
    },
    {
      key: "11",
      label: (
        <span>
          <AuditOutlined /> ค่าใช้จ่าย
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <div>
            {
              <>
                {
                  <PaymentInCaseTab
                    judgeData={
                      judgeData?.currentNewContno === searchData.CONTNO
                        ? judgeData
                        : rejudgeData
                    }
                  />
                }
              </>
            }
          </div>
        </Spin>
      ),
    },

    {
      key: "3",
      label: (
        <span>
          <TransactionOutlined /> ตารางรับชำระ
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <>
            <div>
              <PaymentTab
                judgeData={
                  judgeData?.currentNewContno === searchData.CONTNO
                    ? judgeData
                    : rejudgeData
                }
                token={token}
              />
            </div>
          </>
        </Spin>
      ),
    },
    (roleId === 1 || roleId === 12) && {
      key: "12",
      label: (
        <span>
          <TransactionOutlined /> ตารางรับชำระทางบัญชี
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <>
            <div>
              <PaymentTabAcc
                judgeData={
                  judgeData?.currentNewContno === searchData.CONTNO
                    ? judgeData
                    : rejudgeData
                }
                token={token}
              />
            </div>
          </>
        </Spin>
      ),
    },
    (judgeData?.loanNew || judgeData?.loanJudge) && {
      key: "4",
      label: (
        <span>
          <FileTextOutlined /> ตารางดิว
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <>
            <div>
              <DuePaymentTab
                duePaymentData={duePaymentData}
                beeypupData={beeypupData}
                judgeData={judgeData}
                loanData={loanData}
                searchData={searchData}
                loadLoanData={loadLoanData}
                exportCardDebtor={exportCardDebtor}
              />
            </div>
          </>
        </Spin>
      ),
    },
    {
      key: "5",
      label: (
        <span>
          <FileTextOutlined /> ข้อมูลทรัพย์
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge}>
          <div>
            {judgeData?.asset ? (
              <>{<InvestigationInfoTab judgeData={judgeData} />}</>
            ) : (
              !judgeData?.asset && <Empty description="ไม่มีข้อมูล" />
            )}
          </div>
        </Spin>
      ),
    },
    {
      key: "6",
      label: (
        <span>
          <FileTextOutlined /> ข้อมูลสัญญา(เก่า)
        </span>
      ),
      children: (
        <Spin spinning={loadingLoan} tip="กำลังโหลดข้อมูลสัญญา...">
          <div>
            {/* {loanData ? (
              <>
                <LoanInfoTab judgeData={judgeData} loanData={loanData} />
                <MortgageInfoTab loanData={loanData} />
              </>
            ) : (
              !loadingLoan && <Empty description="ไม่มีข้อมูล" />
            )} */}

            {judgeData?.rejudge_from_id_judge &&
            judgeData?.currentNewContno === searchData?.CONTNO ? (
              <>
                <LoanRejudgeTab
                  judgeData={judgeData}
                  loanData={loanData}
                  rejudgeData={rejudgeData}
                />
                <MortgageInfoTab loanData={loanData} />
              </>
            ) : loanData ? (
              <>
                <LoanInfoTab
                  judgeData={judgeData}
                  loanData={loanData}
                  remarkValueOld={remarkValueOld}
                />
                <MortgageInfoTab loanData={loanData} />
              </>
            ) : (
              !loadingLoan && <Empty description="ไม่มีข้อมูล" />
            )}
          </div>
        </Spin>
      ),
    },
    {
      key: "7",
      label: (
        <span>
          <SolutionOutlined /> ข้อมูลบุคคล
        </span>
      ),
      children: (
        <Spin spinning={loadingLoan} tip="กำลังโหลดข้อมูลบุคคล...">
          <div>
            {loanData ? (
              <>
                <CustomerInfoTab
                  loanData={loanData}
                  loadLoanData={loadLoanData}
                  userId={userId}
                />
                <GuarantorsTab
                  loanData={loanData}
                  loadLoanData={loadLoanData}
                  userId={userId}
                />
              </>
            ) : (
              !loadingLoan && <Empty description="ไม่มีข้อมูล" />
            )}
          </div>
        </Spin>
      ),
    },

    {
      key: "9",
      label: (
        <span>
          <FolderOpenOutlined /> ไฟล์เอกสารในสัญญา
        </span>
      ),
      children: (
        <Spin spinning={loadingImge} tip="กำลังโหลดข้อมู...">
          <div>
            <>
              <UploadImageTab
                fileListByContractCourt={fileListByContractCourt}
                token={token}
                pdfPreviewOpen={pdfPreviewOpen}
                pdfPreviewUrl={pdfPreviewUrl}
                setPdfPreviewOpen={setPdfPreviewOpen}
                setPdfPreviewUrl={setPdfPreviewUrl}
                setIsModalAddImge={setIsModalAddImge}
              />
            </>
          </div>
        </Spin>
      ),
    },
    {
      key: "8",
      label: (
        <span>
          <TwitchOutlined /> memo
        </span>
      ),
      children: (
        <Spin spinning={loadingLoan} tip="กำลังโหลดข้อมูลบุคคล...">
          <div>
            <>
              {
                <>
                  <MemoTab
                    memoDataOld={memoDataOld}
                    setMemoDataOld={setMemoDataOld}
                    memoDataNew={memoDataNew}
                    showNoteOld={showNoteOld}
                    setShowNoteOld={setShowNoteOld}
                    showNoteNew={showNoteNew}
                    setShowNoteNew={setShowNoteNew}
                    editMemoOld={editMemoOld}
                    setEditMemoOld={setEditMemoOld}
                    remarkValueNew={remarkValueNew}
                    setRemarkValueNew={setRemarkValueNew}
                    roleId={roleId}
                    postMemoNew={postMemoNew}
                    postMemoOld={postMemoOld}
                  />
                  <FollowCustomerTab followCusData={followCusData} />
                </>
              }
            </>
          </div>
        </Spin>
      ),
    },
    {
      key: "10",
      label: (
        <span>
          <EyeOutlined /> บันทึกติดตาม
        </span>
      ),
      children: (
        <Spin spinning={loadingImge} tip="กำลังโหลดข้อมู...">
          <div>
            <>{<FollowCustomerTab followCusData={followCusData} />}</>
          </div>
        </Spin>
      ),
    },
    {
      key: "13",
      label: (
        <span>
          <MailOutlined /> การส่งเอกสารหาลูกค้า
        </span>
      ),
      children: (
        <Spin spinning={loadingJudge} tip="กำลังโหลดข้อมู...">
          <div>
            <>
              {
                <MailCustomerTab
                  judgeData={judgeData}
                  mailData={mailData}
                  statusEms={statusEms}
                />
              }
            </>
          </div>
        </Spin>
      ),
    },
  ].filter(Boolean);

  // คงเหลือหลังพิพากษา (สูตรเดียวกับ modal อนุมัติขอผ่อนชำระ)
  const judgeRemaining = (() => {
    const firstJudge = judgeData?.judge?.[0];
    const totalJudgement =
      Number(firstJudge?.judgement || 0) +
      Number(firstJudge?.AROTHR || 0) +
      Number(firstJudge?.costOfUselessness || 0);
    const totalPaid = (judgeData?.chqtran ?? [])
      .filter((r) => r.FLAG !== "C")
      .reduce((sum, item) => sum + parseFloat(item.PAYAMT_N || 0), 0);
    const totalPaidArothr = (judgeData?.chqtran_arothr ?? [])
      .filter((r) => r.FLAG !== "C")
      .reduce((sum, item) => sum + parseFloat(item.PAYAMT || 0), 0);
    return totalJudgement - (totalPaid + totalPaidArothr);
  })();

  const showRender = () => {
    return (
      <>
        <ContractHeader
          judgeData={judgeData}
          loanData={loanData}
          memoDataOld={memoDataOld}
          searchData={searchData}
          rejudgeData={rejudgeData}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 12,
          }}
        >
          {judgeData ? (
            <Space size={10}>
              {/* {judgeData.flagLoanNew === 2 &&
                !judgeData.loanJudge &&
                (roleId === 1 || roleId === 2) && (
                  <Button
                    color="purple"
                    variant="outlined"
                    icon={<FileProtectOutlined />}
                    disabled={judgeRemaining <= 0}
                    onClick={() => setIsModalApproveDue(true)}
                  >
                    อนุมัติขอผ่อนชำระ
                  </Button>
                )} */}
              {judgeData.judge && (
                <Button
                  color="green"
                  variant="outlined"
                  icon={<FileProtectOutlined />}
                  onClick={() => {
                    setIsModalBillAfterCourtOldData(true);
                  }}
                >
                  ดูใบส่งสินค้า
                </Button>
              )}
              {console.log("roleId", roleId)}

              {(roleId === 1 || roleId === 2 || roleId === 6) && (
                <Button
                  ghost
                  variant="outlined"
                  color="red"
                  icon={<FileSearchOutlined />}
                  onClick={() => {
                    if (!loanData) {
                      loadLoanData(judgeData?.judge[0]?.CONTNO);
                      setIsModalPreviewPayment(true);
                    } else {
                      setIsModalPreviewPayment(true);
                    }
                  }}
                  disabled={!judgeData?.ACTIVE && !judgeData?.judge}
                  size="large"
                  style={{ minWidth: 120, borderRadius: 8 }}
                  // disabled={true}
                >
                  {judgeData?.flagLoanNew === 1 || judgeData?.loanJudge !== null
                    ? "พรีวิว เบี้ยปรับ"
                    : "พรีวิว ยอดจ่าย"}
                </Button>
              )}
              {(roleId === 1 ||
                roleId === 2 ||
                roleId === 3 ||
                roleId === 6) && (
                <Button
                  type="primary"
                  ghost
                  icon={<FileTextOutlined />}
                  onClick={() => handleBillRequest()}
                  disabled={!judgeData?.ACTIVE && !judgeData?.judge}
                  size="large"
                  style={{ minWidth: 120, borderRadius: 8 }}
                >
                  ใบเสร็จรับชำระ
                </Button>
              )}
            </Space>
          ) : null}
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          size="large"
          items={tabItems}
          style={{
            background: "#fff",
            padding: "16px",
            borderRadius: THEME.borderRadius,
            boxShadow: THEME.cardShadow,
          }}
        />
      </>
    );
  };

  const currentStatus = judgeData?.judge?.[0]?.currentStatus;
  const hasData = judgeData?.details !== "ไม่พบข้อมูล";

  const canShowRender =
    (hasData &&
      userId === USER_IDS.HIA &&
      HIA_APPROVED_STATUSES.includes(currentStatus)) ||
    (judgeData &&
      userId !== USER_IDS.HIA &&
      roleId === ROLE_IDS.JUDGE_REVIEWER &&
      currentStatus >= JUDGMENT_REVIEWED_THRESHOLD) ||
    roleId !== ROLE_IDS.JUDGE_REVIEWER;

  return (
    <Spin spinning={loadingJudge} size="large" tip="กำลังโหลดข้อมูล...">
      <div style={{ padding: "0 0 24px" }}>
        {canShowRender ? (
          showRender()
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Space direction="vertical">
                <Text strong style={{ fontSize: 16 }}>
                  ไม่มีข้อมูล
                </Text>
                <Text type="secondary">
                  กรุณาค้นหาเลขสัญญาเพื่อดูรายละเอียด
                </Text>
              </Space>
            }
          />
        )}
      </div>
      {isModalpayIn && (
        <PayInSlipModal
          open={isModalpayIn}
          onClose={() => setIsModalPayIn(false)}
          dataDB2={loanData}
          billPayment={billPayment}
          lawsuitData={judgeData?.lawsult}
        />
      )}
      {isModalAddImge && (
        <AddImage
          open={isModalAddImge}
          close={() => setIsModalAddImge(false)}
          dataDefault={judgeData}
          onSuccess={handleReload}
        />
      )}
      {isModalPreviewPayment && (
        <PreviewPayment
          open={isModalPreviewPayment}
          close={() => setIsModalPreviewPayment(false)}
          dataDefault={judgeData}
          dataContno={loanData}
        />
      )}

      {isModalBillAfterCourtOldData && (
        <BillAfterCourtOldData
          open={isModalBillAfterCourtOldData}
          close={() => setIsModalBillAfterCourtOldData(false)}
          dataDefault={judgeData?.judge?.[0]}
          status={judgeData?.flagLoanNew}
        />
      )}

      {(() => {
        const firstJudge = judgeData?.judge?.[0];
        const totalJudgement =
          Number(firstJudge?.judgement || 0) +
          Number(firstJudge?.AROTHR || 0) +
          Number(firstJudge?.costOfUselessness || 0);

        const totalPaid = (judgeData?.chqtran ?? [])
          .filter((r) => r.FLAG !== "C")
          .reduce((sum, item) => sum + parseFloat(item.PAYAMT_N || 0), 0);

        const totalPaidArothr = (judgeData?.chqtran_arothr ?? [])
          .filter((r) => r.FLAG !== "C")
          .reduce((sum, item) => sum + parseFloat(item.PAYAMT || 0), 0);

        const totalPaidAll = parseFloat(totalPaid + totalPaidArothr);
        const paymentProgress =
          totalJudgement > 0 ? (totalPaidAll / totalJudgement) * 100 : 0;

        return (
          <Modal
            title={
              <Space>
                <CheckCircleOutlined style={{ color: THEME.success }} />
                <span>อนุมัติขอผ่อนชำระ</span>
              </Space>
            }
            open={isModalApproveDue}
            onOk={handleApproveDue}
            onCancel={() => {
              setIsModalApproveDue(false);
              setApproveDueDate(null);
            }}
            okText="อนุมัติ"
            cancelText="ยกเลิก"
            confirmLoading={loadApprovDue}
            centered
            width={480}
            okButtonProps={{
              style: { background: THEME.success, borderColor: THEME.success },
            }}
            styles={{
              header: { paddingBottom: 12 },
              body: { paddingTop: 4 },
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #f6ffed 0%, #fff 100%)",
                border: "1px solid #b7eb8f",
                borderRadius: THEME.borderRadius,
                padding: "18px 20px",
                marginBottom: 20,
              }}
            >
              <Space align="center" style={{ marginBottom: 14 }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: "#fff",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  <WalletOutlined
                    style={{ color: THEME.success, fontSize: 15 }}
                  />
                </span>
                <Text strong style={{ fontSize: 15 }}>
                  ความคืบหน้าการชำระ
                </Text>
                <Tag
                  color={paymentProgress >= 100 ? "success" : "processing"}
                  style={{ borderRadius: 10, marginInlineEnd: 0 }}
                >
                  {Number(paymentProgress ? paymentProgress.toFixed(1) : 0)}%
                </Tag>
              </Space>
              <Progress
                percent={Number(
                  paymentProgress ? paymentProgress.toFixed(1) : 0,
                )}
                strokeColor={{ "0%": THEME.success, "100%": "#52c41a" }}
                trailColor="#e6f7e6"
                size={{ width: "100%", height: 10 }}
                style={{ marginBottom: 16 }}
              />
              <Row gutter={12}>
                <Col span={12}>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #f0f0f0",
                      borderRadius: 8,
                      padding: "10px 12px",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      type="secondary"
                      style={{
                        fontSize: 13,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      ชำระแล้ว
                    </Text>
                    <Text strong style={{ color: THEME.success, fontSize: 17 }}>
                      {formatMoney(totalPaidAll)}{" "}
                      <span
                        style={{
                          color: "#aaa",
                          fontSize: 13,
                          fontWeight: 400,
                        }}
                      >
                        บาท
                      </span>
                    </Text>
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #f0f0f0",
                      borderRadius: 8,
                      padding: "10px 12px",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      type="secondary"
                      style={{
                        fontSize: 13,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      คงเหลือ
                    </Text>
                    <Text strong style={{ color: THEME.danger, fontSize: 17 }}>
                      {formatMoney(Math.max(0, totalJudgement - totalPaidAll))}{" "}
                      <span
                        style={{
                          color: "#aaa",
                          fontSize: 13,
                          fontWeight: 400,
                        }}
                      >
                        บาท
                      </span>
                    </Text>
                  </div>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#fffbe6",
                  border: `1px solid ${THEME.warning}`,
                  borderRadius: 8,
                  padding: "10px 14px",
                  marginTop: 12,
                }}
              >
                <Space size={6}>
                  <ExclamationCircleOutlined
                    style={{ color: THEME.warning, fontSize: 15 }}
                  />
                  <Text strong style={{ fontSize: 13 }}>
                    ยอดขอผ่อน 10%
                  </Text>
                </Space>
                <Text strong style={{ color: THEME.warning, fontSize: 17 }}>
                  {formatMoney(totalJudgement / 10)}{" "}
                  <span
                    style={{
                      color: "#aaa",
                      fontSize: 13,
                      fontWeight: 400,
                    }}
                  >
                    บาท
                  </span>
                </Text>
              </div>
            </div>

            <Divider style={{ margin: "16px 0" }} />

            <Space direction="vertical" size={6} style={{ width: "100%" }}>
              <Space size={6}>
                <CalendarOutlined style={{ color: THEME.primary }} />
                <Text strong>วันที่เริ่มดิว</Text>
              </Space>
              <ThaiDatePicker
                style={{ width: "100%" }}
                format="DD MMM YYYY"
                value={approveDueDate}
                onChange={(date) => setApproveDueDate(date)}
              />
            </Space>
          </Modal>
        );
      })()}
    </Spin>
  );
};

const ContractDetailNew = MotionHoc(Main);
export default ContractDetailNew;
